import React, { useEffect, useState } from "react";
import Api from "../../../Api/api";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import AdminEditFunctionsTable from "./table";
import { AES, enc } from "crypto-js";
import { useStateValue } from "../../../states/StateProvider";
import { useForm } from "react-hook-form";

const AdminEditFunctions = () => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingSave, setLoadingSave] = useState(false);

    const [{ secretKey, portal }, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8));

    const {
        register, getValues, setValue, watch, handleSubmit, formState, reset, formState: { errors, touchedFields },
        control
    } = useForm({ mode: "onChange" });
    const { isValid } = formState;

    useEffect(() => {
        getData().then(r => r);
    }, [portal]);

    const getData = async () => {
        if (portal) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append('portal', portal);
                const res = await Api().post('/sp_getDataAdminRespFunctions', formData);
                setTableData(res.data || []);
            } catch (e) {
                toast.error('Fehler beim Laden der Funktionen!');
                console.error(e);
            }
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        setLoadingSave(true);

        try {
            const nextId = Math.max(...tableData.map(item => item.ID || 0), 0) + 1;
            const formData = new FormData();
            formData.append('portal', portal);
            formData.append('ID', nextId);
            formData.append('function', data.newFunction.trim());

            await Api().post('/sp_setRespFunction', formData);
            toast.success('Neue Funktion wurde hinzugefügt');
            reset();
            await getData();
        } catch (e) {
            toast.error('Fehler beim Hinzufügen der neuen Funktion');
            console.error(e);
        } finally {
            setLoadingSave(false);
        }
    };

    function portalSelect(e) {
        dispatch({ type: 'SET_PORTAL', item: e.target.value });
        localStorage.setItem('portal', e.target.value);
        setTableData([]);
    }

    return (
        <div className='dashboardContainer'>
            <div className='flex justify-start items-center content-center pb-5'>
                <h2 className='text-2xl lg:text-left'>Ansprechpartner Funktionen</h2>
                {
                    <div className='flex justify-start items-center w-fit bg-transparent py-2 px-4 ml-2 rounded-sm'>
                        <p className='w-fit mr-2 text-grey'>Portal: </p>
                        <select
                            disabled={loading}
                            className='col-span-2 text-center text-mainBlue mx-auto pr-1 bg-transparent border border-offWhite rounded-sm lg:w-fit'
                            onChange={portalSelect}
                            value={portal}
                        >
                            <option selected value='dgg'>DGG</option>
                            <option value='ruv'>R+V</option>
                        </select>
                    </div>
                }
            </div>

            <div className='bg-white rounded-md mb-5 px-5 pt-4 pb-10 min-h-fit'>
                {
                    loading && <div className='centerItemsRelative h-72'><BeatLoader size='10px' /></div>
                }
                {
                    !loading && tableData.length > 0 &&
                    <table className='min-w-full text-left px-10 border border-offWhite'>
                        <thead className="whitespace-nowrap border-y border-silver border-x-0">
                            <tr className='text-lg'>
                                <th className="text-grey pl-1.5" scope="col">ID</th>
                                <th className="text-grey pl-1.5" scope="col">Funktion</th>
                                <th className="text-grey pl-1.5" scope="col"></th>
                            </tr>
                        </thead>
                        {
                            tableData?.map((td, i) => (
                                <AdminEditFunctionsTable
                                    key={td.ID || i}
                                    index={i}
                                    id={td.ID}
                                    title={td.Funktion}
                                    portal={portal}
                                    onUpdate={getData}
                                />
                            ))
                        }
                    </table>
                }
                <hr />
                <div className='flex flex-col w-12/12 text-center mt-12'>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <section>
                            <h2 className='font-bold text-lg my-2'>Neue Funktion hinzufügen</h2>
                            <input type='text'
                                placeholder='Neue Funktion'
                                className='w-96'
                                {...register('newFunction')}
                                style={{ border: errors.newFunction && '1px solid red' }}
                            />
                        </section>
                        <section>
                            <input
                                className={`${(watch('newFunction') !== '' && watch('newFunction') !== undefined) ? 'bg-mainBlue cursor-pointer' : 'bg-grey cursor-no-drop '} w-52 mt-4 text-white hover:bg-offWhite hover:text-mainBlue text-center px-3 py-2 rounded-md`}
                                type="submit"
                                disabled={!watch('newFunction') || watch('newFunction') === ''}
                                value={`${loadingSave ? 'speichere...' : 'Speichern'}`}
                            />
                        </section>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminEditFunctions;
